import { Layout, Switch } from 'antd';
import { Content, Header } from 'antd/lib/layout/layout';
import { type FC, useState } from 'react';
import { CalendarGrid } from './components/CalendarGrid/CalendarGrid';
import { CalendarProvider } from './components/CalendarGrid/useCalendarState';
import { DistrictsTableViewNew } from './components/DistrictsTableViewNew';

export const DistrictsPageViewNew: FC = () => {
  const [switchTableChecked, setSwitchTableChecked] = useState<boolean>(false);
  const switchTable = (checked: boolean): void => {
    setSwitchTableChecked(checked);
  };

  return (
    <Layout>
      <Header
        style={{
          backgroundColor: '#1890ff',
        }}
      >
        <Switch
          className="app-switch"
          style={{
            backgroundColor: switchTableChecked ? '#0050b3' : '#096dd9',
          }}
          checkedChildren="District with drivers"
          unCheckedChildren="Driver with districts"
          checked={switchTableChecked}
          onChange={switchTable}
        />
      </Header>
      <Content>
        {switchTableChecked ? (
          <DistrictsTableViewNew />
        ) : (
          <CalendarProvider>
            <CalendarGrid />
          </CalendarProvider>
        )}
      </Content>
    </Layout>
  );
};
